import { render, staticRenderFns } from "./search-panel.vue?vue&type=template&id=70b8d33c&scoped=true&"
import script from "./search-panel.vue?vue&type=script&lang=js&"
export * from "./search-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b8d33c",
  null
  
)

export default component.exports